import React from "react";

/**
 * NotificationTypeIndicator Component
 *
 * Small utility component for showing notification type with appropriate colors
 */
const NotificationTypeIndicator = ({ type, isRead = false }) => {
  const getTypeColor = (notificationType) => {
    switch (notificationType) {
      case "follow":
        return "bg-red-500";
      case "unfollow":
        return "bg-gray-500";
      case "fighter_cancelled":
        return "bg-orange-500";
      case "like":
        return "bg-pink-500";
      case "comment":
        return "bg-blue-500";
      case "mention":
        return "bg-purple-500";
      case "system":
        return "bg-gray-500";
      case "message.liked":
        return "bg-pink-500";
      case "message.replied":
        return "bg-blue-500";
      default:
        return "bg-blue-500";
    }
  };

  // Don't show indicator for read notifications
  if (isRead) {
    return null;
  }

  return (
    <div
      className={`w-2 h-2 rounded-full flex-shrink-0 ${getTypeColor(type)}`}
      title={`${type} notification`}
    />
  );
};

export default NotificationTypeIndicator;
